export enum SearchDataType {    
    Topics,
    TopicMetaData,
    TopicSubTopicKeys,
    TopicTags,
    SubTopics,
    SubTopicMetaData,
}